import { render, staticRenderFns } from "./FileContainer.vue?vue&type=template&id=8679a9d0&"
import script from "./FileContainer.vue?vue&type=script&lang=js&"
export * from "./FileContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports